import { render } from "./DesktopMessageCaseSelector.vue?vue&type=template&id=5eff9f9e&scoped=true&ts=true"
import script from "./DesktopMessageCaseSelector.vue?vue&type=script&lang=ts"
export * from "./DesktopMessageCaseSelector.vue?vue&type=script&lang=ts"

import "./DesktopMessageCaseSelector.vue?vue&type=style&index=0&id=5eff9f9e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eff9f9e"]])

export default __exports__